import { apiCall } from '../../utils/APIFunctions';
import KPConfig from '../../KPConfig';

export function fetchSignupTemplates(locale) {
  return apiCall(`${KPConfig.backendUrl}/start/templates/${locale}`, "GET");
}

export function createAccount(params) {
  return apiCall(`${KPConfig.backendUrl}/quick-trial`, "POST", JSON.stringify(params));
}

export function login(params) {
  return apiCall(`${KPConfig.backendUrl}/clientlogin`, "POST", JSON.stringify(params));
}

export function sendPasswordReset(params) {
  return apiCall(`${KPConfig.backendUrl}/password-reset`, "POST", JSON.stringify(params));
}

export function sendEmailVerificationEmail(email) {
  return apiCall(`${KPConfig.backendUrl}/start/sendEmailVerificationEmail`, "POST", JSON.stringify({email: email}));
}

export function sendLoginEmail(email) {
  return apiCall(`${KPConfig.backendUrl}/sendLoginEmail`, "POST", JSON.stringify({email: email}));
}